import { render } from "./StyleAnalysesChart.vue?vue&type=template&id=61b89d39&scoped=true&ts=true"
import script from "./StyleAnalysesChart.vue?vue&type=script&lang=ts"
export * from "./StyleAnalysesChart.vue?vue&type=script&lang=ts"

import "./StyleAnalysesChart.vue?vue&type=style&index=0&id=61b89d39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b89d39"]])

export default __exports__